import React from 'react';
import { Layout } from 'react-admin';
import ExpMenu from './menu';

const ExpLayout = (props) => <Layout {...props} menu={ExpMenu} />;

export default ExpLayout;
